<template>
  <div>
    <v-card elevation="2" class="mx-auto ml-5 mr-5 my-5">
      <v-data-table
        :headers="headers"
        :items="item_items"
        disable-pagination
        :hide-default-footer="true"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>List Item</v-toolbar-title>
          </v-toolbar>
          <v-row class="ml-2 mt-4">
            <v-col cols="3">
              <v-btn
                block
                depressed
                small
                color="primary"
                height="35px"
                @click="showFilter()"
              >
                <v-icon>mdi-filter</v-icon>
                Filter
              </v-btn>
              <v-dialog
                v-model="filterModalVisible"
                max-width="500px"
                persistent
              >
                <v-card>
                  <v-card-title>
                    Filter berdasarkan
                    {{ swipeMetodeFilterAndCompare[metodeFilter] }}
                  </v-card-title>
                  <v-card-text>
                    <v-radio-group v-model="metodeFilter" row>
                      <v-radio label="tanggal" value="date"></v-radio>
                      <v-radio label="batas waktu" value="due_date"></v-radio>
                    </v-radio-group>
                    <v-autocomplete
                      v-model="nama_item"
                      :items="dataUniqueItems"
                      item-text="item_name"
                      item-value="item_name"
                      label="Nama Item"
                    ></v-autocomplete>
                    <v-text-field
                      type="datetime-local"
                      v-model="fromDateFilter"
                      label="Dari Tanggal"
                    ></v-text-field>
                    <v-text-field
                      type="datetime-local"
                      v-model="toDateFilter"
                      label="Sampai Tanggal"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="[(filterModalVisible = false)]"
                      >Cancel</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="handleFilterByDate"
                      >Update</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row v-if="showFilteredTitle" class="ml-2">
            <v-col class="d-flex"
              ><h5>
                Daftar Items
                <span class="font-weight-bold">{{ nama_item }}</span>
                {{ swipeMetodeFilterAndCompare[metodeFilter] }}
                <span style="color: #1976d2" class="font-weight-bold">{{
                  formatdate(fromDateFilter)
                }}</span>
                sampai
                <span style="color: #1976d2" class="font-weight-bold">{{
                  formatdate(toDateFilter)
                }}</span>
              </h5>
              <v-btn
                @click="resetFilter"
                style="margin-left: 10px"
                outlined
                small
                fab
                color="indigo"
              >
                <v-icon>mdi-backup-restore</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.no`]="{ item }">
          {{
            item_items.indexOf(item) + 1 + (currentPage - 1) * pageSize + "."
          }}
        </template>
        <template v-slot:[`item.harga_jual`]="{ item }">
          {{ convertCurrency(item.harga_jual) }}
        </template>
        <template v-slot:[`item.harga_beli`]="{ item }">
          {{ convertCurrency(item.harga_beli) }}
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <v-chip
            @click="detailSubmission(item)"
            small
            class="ma-2 white--text"
            label
            :color="submissionColor[item.type]"
            ><v-icon left small>{{ submissionIcon[item.type] }}</v-icon
            >{{ item.type }}</v-chip
          >
        </template>
        <template v-slot:[`item.submission_due_date`]="{ item }">
          {{ formatdate(item.submission_due_date) }}
        </template>
        <template v-slot:no-data>
          <span class="text-center">No data available.</span>
        </template>
        <template v-slot:footer v-if="showFilteredTitle">
          <v-divider></v-divider>
          <div style="padding: 0 5em">
            <v-row no-gutters>
              <v-col sm="6" md="6">
                <div>
                  <h5>
                    Total Pemasukan:
                    <b style="color: #43a047"
                      >{{ convertCurrency(totalPemasukan) }} ({{
                        countPemasukan
                      }})</b
                    >
                  </h5>
                </div>
              </v-col>
              <v-col sm="6" md="6">
                <div>
                  <h5>
                    Total Pengeluaran:
                    <b style="color: red"
                      >{{ convertCurrency(totalPengeluaran) }} ({{
                        countPengeluaran
                      }})</b
                    >
                  </h5>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-data-table>
      <div style="padding: 20px" class="d-flex">
        <v-col class="d-flex" cols="12" sm="1">
          <small style="margin-top: 30px">Item show</small>
        </v-col>
        <v-col class="d-flex" cols="12" sm="1">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            @change="handlePageSizeChange"
            style="font-size: 10px"
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
          <v-pagination
            style="width: auto"
            v-model="currentPage"
            :length="totalPages"
            total-visible="10"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange"
          ></v-pagination>
          <small style="margin-top: 28px"
            >{{ from }}-{{ to }} of {{ totalData }}</small
          >
        </v-col>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import itemTemplate from "@/components/ItemTemplate.vue";
import { formatCurrency } from "@/libs/number";
import dayjs from "dayjs";
import moment from "moment";
export default {
  data: () => ({
    itemTemplate,
    dialog: false,
    expand: false,
    role: "",
    permission: [],
    showError: false,
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no",
      },
      {
        text: "Nama",
        align: "left",
        value: "item_name",
      },
      { text: "Due Date", value: "submission_due_date" },
      { text: "Quantity", value: "qty" },
      { text: "Harga Jual", value: "harga_jual" },
      { text: "Harga Beli", value: "harga_beli" },
      { text: "Discount", value: "discount" },
      { text: "PPN", value: "ppn" },
      { text: "Tipe Submission", value: "type" },
    ],
    item_items: [],
    default_items: [],
    item: "",
    submissionColor: {
      PEMASUKAN: "green",
      PENGELUARAN: "red",
      UNDEFINED: "primary",
    },
    submissionIcon: {
      PEMASUKAN: "call_received",
      PENGELUARAN: "call_made",
      UNDEFINED: "loop",
    },
    swipeMetodeFilterAndCompare: {
      date: "tanggal",
      due_date: "batas waktu",
    },
    filterModalVisible: false,
    metodeFilter: "date",
    dataUniqueItems: [],
    toDateFilter: null,
    fromDateFilter: null,
    nama_item: null,
    totalPemasukan: 0,
    totalPengeluaran: 0,
    countPemasukan: 0,
    countPengeluaran: 0,
    showFilteredTitle: false,
    pageSizes: [10, 50, 100],
    currentPage: 1,
    totalPages: 0,
    pageSize: 10,
    from: 0,
    to: 0,
    totalData: 0,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Buat Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      dataProducts: "products/getProducts",
      createProducts: "products/createProducts",
      updateProducts: "products/updateProducts",
      deleteProducts: "products/deleteProducts",
      getUserById: "user/getUserById",
      getItemsUnique: "item/getItemsUnique",
      searchItemWithDate: "item/searchItemWithDate",
      dataItems: "products/getUserItems",
    }),
    formatdate(value) {
      return moment(value).format("DD-MM-YYYY HH:mm");
    },
    async handleFilterByDate() {
      if (
        !dayjs(this.fromDateFilter).isValid() ||
        !dayjs(this.toDateFilter).isValid()
      ) {
        return this.$notify({
          group: "custom-notification",
          type: "error",
          title: "Error!",
          text: "Format tanggal salah!",
        });
      }
      if (this.fromDateFilter > this.toDateFilter) {
        return this.$notify({
          group: "custom-notification",
          type: "error",
          title: "Error!",
          text: "Dari tanggal tidak boleh lebih besar!",
        });
      }
      this.default_items = [];
      this.item_items = [];
      let payload = {
        column: this.metodeFilter,
        nama_item: this.nama_item,
        date_from: dayjs(this.fromDateFilter)
          .add(59, "second")
          .format("YYYY-MM-DDTHH:mm:ss"),
        date_to: dayjs(this.toDateFilter)
          .add(59, "second")
          .format("YYYY-MM-DDTHH:mm:ss"),
        page: this.pageSizes,
        jum: this.pageSize,
      };

      let response = await this.searchItemWithDate(payload);
      this.totalPages = response.data.attributes.items.last_page;
      this.currentPage = response.data.attributes.items.current_page;
      this.from = response.data.attributes.items.from;
      this.to = response.data.attributes.items.to;
      this.totalData = response.data.attributes.items.total;
      await forEach(response.data.attributes.items.data, (data) => {
        data.qty = Number(data.qty);
        data.harga_jual = Number(data.harga_jual);
        data.harga_beli = Number(data.harga_beli);
        data.discount = Number(data.discount) + "%";
        data.ppn = Number(data.ppn) + "%";
        data.type =
          data.submission_id == 0 ? "UNDEFINED" : data.submission.type;
        data.submission_due_date = data.submission.due_date;
        this.default_items.push(data);
        this.item_items.push(data);
      });
      this.totalPemasukan = response.data.attributes.sum_pemasukan;
      this.totalPengeluaran = response.data.attributes.sum_pengeluaran;
      this.countPemasukan = response.data.attributes.count_pemasukan;
      this.countPengeluaran = response.data.attributes.count_pengeluaran;
      this.showFilteredTitle = true;
      this.filterModalVisible = false;
    },
    async resetFilter() {
      this.default_items = [];
      this.item_items = [];
      this.showFilteredTitle = false;
      this.filterModalVisible = false;
      this.totalPemasukan = 0;
      this.totalPengeluaran = 0;
      this.countPemasukan = 0;
      this.countPengeluaran = 0;
      this.toDateFilter = null;
      this.fromDateFilter = null;
      this.nama_item = null;
      const dataItem = await this.dataItems({
        page: this.pageSizes,
        jum: this.pageSize,
      });
      this.totalPages = dataItem.data.attributes.items.last_page;
      this.currentPage = dataItem.data.attributes.items.current_page;
      this.from = dataItem.data.attributes.items.from;
      this.to = dataItem.data.attributes.items.to;
      this.totalData = dataItem.data.attributes.items.total;
      await forEach(dataItem.data.attributes.items.data, (data) => {
        data.qty = Number(data.qty);
        data.harga_jual = Number(data.harga_jual);
        data.discount = Number(data.discount) + "%";
        data.ppn = Number(data.ppn) + "%";
        data.harga_beli = Number(data.harga_beli);
        data.type =
          data.submission_id == 0 ? "UNDEFINED" : data.submission.type;
        data.submission_due_date = data.submission.due_date;
        this.default_items.push(data);
        this.item_items.push(data);
      });
    },
    async showFilter() {
      this.filterModalVisible = true;
      let response = await this.getItemsUnique();
      await forEach(response.data.attributes, (data) => {
        this.dataUniqueItems.push(data);
      });
    },
    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },
    async initialize() {
      const userLogin = JSON.parse(window.localStorage.getItem("user_data"));
      this.role = userLogin.roles[0].name;
      this.permission = userLogin.permissions;
      const dataItem = await this.dataItems({
        page: this.pageSizes,
        jum: this.pageSize,
      });
      this.totalPages = dataItem.data.attributes.items.last_page;
      this.currentPage = dataItem.data.attributes.items.current_page;
      this.from = dataItem.data.attributes.items.from;
      this.to = dataItem.data.attributes.items.to;
      this.totalData = dataItem.data.attributes.items.total;
      await forEach(dataItem.data.attributes.items.data, (data) => {
        data.qty = Number(data.qty);
        data.harga_jual = Number(data.harga_jual);
        data.harga_beli = Number(data.harga_beli);
        data.discount = Number(data.discount) + "%";
        data.ppn = Number(data.ppn) + "%";
        data.type =
          data.submission_id == 0 ? "UNDEFINED" : data.submission.type;
        data.submission_due_date = data.submission.due_date;
        this.default_items.push(data);
        this.item_items.push(data);
      });

      // console.log('this.item_products', this.item_products)
      // console.log('this.items', this.item_items)
      // console.log('this.defitems', this.default_items)
    },

    detailSubmission(item) {
      if (item.type == "PEMASUKAN") {
        if (this.showFilteredTitle) {
          this.$router.push(
            "/pemasukan?id=" +
              item.submission_id +
              "&category_id=" +
              item.category_id
          );
        } else {
          this.$router.push(
            "/pemasukan?id=" +
              item.submission_id +
              "&category_id=" +
              item.submission.category_id
          );
        }
      } else if (item.type == "PENGELUARAN") {
        if (this.showFilteredTitle) {
          this.$router.push(
            "/pengeluaran?id=" +
              item.submission_id +
              "&category_id=" +
              item.category_id
          );
        } else {
          this.$router.push(
            "/pengeluaran?id=" +
              item.submission_id +
              "&category_id=" +
              item.submission.category_id
          );
        }
      }
    },

    itemSelected(item) {
      this.editedItem.name = item.item_name;
      this.editedItem.harga_jual = item.harga_jual;
      this.editedItem.harga_beli = item.harga_beli;
      // console.log('Selected', this.selected)
      // console.log('Selected item', item)
      // this.items[i].item_id = item.item_id.id
      // console.log('item', item)
      // console.log('this.items', this.items)
    },

    setLabel(item) {
      return item.item_name;
    },

    inputChange(text) {
      this.item_items = this.default_items;
      if (text != "") {
        this.item_items = this.item_items.filter((item) =>
          item.item_name.toLowerCase().includes(text.toLowerCase())
        );
        this.editedItem.name = text;
      }
    },

    editItem(data) {
      this.selected = find(this.item_items, ["item_name", data.name]);
      if (this.selected == undefined) {
        this.selected = {
          id: 0,
          item_name: data.name,
          qty: 0,
          submission_id: 0,
          product_id: 0,
          user_id: data.user_id,
          company_id: data.company_id,
          created_at: "",
          updated_at: "",
          harga_jual: data.harga_jual,
          harga_beli: data.harga_beli,
        };
        this.item_items.push(this.selected);
      }
      // this.selected = data.name
      // console.log('Selected', this.selected)
      // console.log('this.item_items', this.item_items)
      // console.log('data', data)
      // forEach(data.items, item => {
      //   item.harga_jual = Number(item.harga_jual)
      //   item.harga_jual = Number(item.harga_jual)
      // })
      // this.items = data.items
      this.editedIndex = this.item_products.indexOf(data);
      this.editedItem = Object.assign({}, data);
      this.dialog = true;
      // console.log('this.item_items', this.item_items)
    },

    // async deleteItem(item) {
    //   const index = this.item_products.indexOf(item);
    //   if(confirm("Apakah anda yakin menghapus item ini?")){
    //      await this.deleteProducts(item.id)
    //      this.item_products.splice(index, 1);
    //   }
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async handlePageChange(value) {
      this.item_items = [];
      this.currentPage = value;
      let dataItem;
      if (this.toDateFilter && this.fromDateFilter) {
        let payload = {
          column: this.metodeFilter,
          nama_item: this.nama_item,
          date_from: dayjs(this.fromDateFilter).format("YYYY-MM-DDTHH:mm"),
          date_to: dayjs(this.toDateFilter).format("YYYY-MM-DDTHH:mm"),
          page: value,
          jum: this.pageSize,
        };
        dataItem = await this.searchItemWithDate(payload);
      } else {
        dataItem = await this.dataItems({ page: value, jum: this.pageSize });
      }
      this.totalPages = dataItem.data.attributes.items.last_page;
      this.currentPage = dataItem.data.attributes.items.current_page;
      this.from = dataItem.data.attributes.items.from;
      this.to = dataItem.data.attributes.items.to;
      this.totalData = dataItem.data.attributes.items.total;
      await forEach(dataItem.data.attributes.items.data, (data) => {
        data.qty = Number(data.qty);
        data.harga_jual = Number(data.harga_jual);
        data.harga_beli = Number(data.harga_beli);
        data.discount = Number(data.discount) + "%";
        data.ppn = Number(data.ppn) + "%";
        data.type =
          data.submission_id == 0 ? "UNDEFINED" : data.submission.type;
        data.submission_due_date = data.submission.due_date;
        this.default_items.push(data);
        this.item_items.push(data);
      });
    },
    async handlePageSizeChange(size) {
      this.item_items = [];
      this.pageSize = size;
      this.currentPage = 1;
      let dataItem;
      if (this.toDateFilter && this.fromDateFilter) {
        let payload = {
          column: this.metodeFilter,
          nama_item: this.nama_item,
          date_from: dayjs(this.fromDateFilter).format("YYYY-MM-DDTHH:mm"),
          date_to: dayjs(this.toDateFilter).format("YYYY-MM-DDTHH:mm"),
          page: this.currentPage,
          jum: size,
        };
        dataItem = await this.searchItemWithDate(payload);
      } else {
        dataItem = await this.dataItems({ page: this.currentPage, jum: size });
      }
      this.totalPages = dataItem.data.attributes.items.last_page;
      this.currentPage = dataItem.data.attributes.items.current_page;
      this.from = dataItem.data.attributes.items.from;
      this.to = dataItem.data.attributes.items.to;
      this.totalData = dataItem.data.attributes.items.total;
      await forEach(dataItem.data.attributes.items.data, (data) => {
        data.qty = Number(data.qty);
        data.harga_jual = Number(data.harga_jual);
        data.discount = Number(data.discount) + "%";
        data.ppn = Number(data.ppn) + "%";
        data.harga_beli = Number(data.harga_beli);
        data.type =
          data.submission_id == 0 ? "UNDEFINED" : data.submission.type;
        data.submission_due_date = data.submission.due_date;
        this.default_items.push(data);
        this.item_items.push(data);
      });
    },
    async save() {
      if (this.editedIndex > -1) {
        try {
          // console.log(this.editedItem, 'this.editedItem')
          const response = await this.updateProducts(this.editedItem);
          response.data.attributes[0].harga_beli = Number(
            response.data.attributes[0].harga_beli
          );
          response.data.attributes[0].harga_jual = Number(
            response.data.attributes[0].harga_jual
          );
          Object.assign(
            this.item_products[this.editedIndex],
            response.data.attributes[0]
          );
        } catch (e) {
          console.log(e);
        }
      } else {
        // console.log('this.selected', this.selected)
        const response = await this.createProducts(this.editedItem);
        response.data.attributes.harga_beli = Number(
          response.data.attributes.harga_beli
        );
        response.data.attributes.harga_jual = Number(
          response.data.attributes.harga_jual
        );
        this.item_products.splice(0, 0, response.data.attributes);
      }
      this.close();
    },
  },
};
</script>
<style>
.vue-suggestion .vs__input {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid black;
  max-height: 400px;
  overflow-y: auto;
  font-size: 16px;
  color: black;
  position: relative;
}
.vue-suggestion .vs__list {
  width: 100%;
  text-align: left;
  border: none;
  border-top: none;
  max-height: 400px;
  overflow-y: auto;
  border-bottom: 1px solid #023d7b;
  position: relative;
}
.vue-suggestion .vs__list .vs__list-item {
  position: relative;
  z-index: 1;
  background-color: #fff;
  padding: 10px;
  border-left: 1px solid #023d7b;
  border-right: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
  border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
  background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
  position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
  cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
  background-color: #f3f6fa;
}
</style>